const CostingType = {
  SET_COSTING_REQUESTS_TODOLIST: 'SET_COSTING_REQUESTS_TODOLIST',
  SET_COSTING_TODO_LIST_COUNT: 'SET_COSTING_TODO_LIST_COUNT',
  SET_SELECTED_IDS_ARRAY: 'SET_SELECTED_IDS_ARRAY',
  SET_FILTER_SORT_DATA: 'COSTING_TODO_SET_FILTER_SORT_DATA',
  GET_MAIN_SAMPLES: 'GET_MAIN_SAMPLES',
  CATEGORY: 'CATEGORY',
  GET_OTHER_SAMPLES: 'GET_OTHER_SAMPLES',
  SET_TODO_LIST_COUNT: 'SET_TODO_LIST_COUNT',
  SUPPLIER_BRAND: 'SUPPLIER_BRAND',
  SET_COSTING_STATS: 'SET_COSTING_STATS',
};

export default CostingType;
